import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScrollDetectDirective } from './scroll-detect.directive';

@NgModule({
  imports: [CommonModule, RouterModule],
  exports: [ScrollDetectDirective],
  declarations: [ScrollDetectDirective],
})
export class ScrollDetectDirectiveModule {}
